<template>
  <v-col
    cols="12"
    sm="6"
    md="3"
  >
    <div class="d-flex align-center">
      <vue-skeleton-loader
        rounded
        :width="54"
        :height="54"
      />
      <div class="ms-3">
        <vue-skeleton-loader
          class="mt-1"
          :width="60"
          :height="12"
        />
        <vue-skeleton-loader
          class="mt-1"
          :width="20"
          :height="14"
        />
      </div>
    </div>
  </v-col>
</template>

<script>
import VueSkeletonLoader from 'skeleton-loader-vue'

export default {
  components: {
    VueSkeletonLoader,
  },

}
</script>

<style>

</style>
